import { IPerson } from "../models/IPerson";

export const HprCacheKeys = {
    HprSettings: "hpr:HprSettings",
    PersonList: (ids: Array<IPerson["id"]>) => {
        return ["hpr:PersonList", ids];
    },

    PersonInstance: (id: number) => ["hpr:Person", id],
    PersonListInstance: (id: number) => ["hpr:PersonOnList", id],

    CompanyList: (token: string | null) => {
        return ["hpr:CompanyList", token];
    },
};
